import Form from './Form';
import { OrganogramProvider } from './organogram/contexts/OrganogramContext';

export default function FormWrapper() {
    return (
        <OrganogramProvider>
            <Form />
        </OrganogramProvider>
    );
};
